const DIRECT_LINKS_EVENTS = {
  DIRECT_LINKS_IMPRESSION: 'DIRECT_LINKS_IMPRESSION',
  DIRECT_LINKS_CLICK: 'DIRECT_LINKS_CLICK'
};

export {DIRECT_LINKS_EVENTS};
